// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wsa-chat {
  margin: 20px auto;
}

.wsa-markdown {
  text-align: left;
  line-height: 1.6;
  font-size: 15px;
  color: var(--text);
}

.wsa-markdown h3 {
  margin: 1rem 0 0.5rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-strong);
}

.wsa-markdown p {
  margin: 0 0 0.75rem;
}

.wsa-markdown ul,
.wsa-markdown ol {
  margin: 0.5rem 0 0.75rem;
  padding-left: 1.25rem;
}

.wsa-markdown li {
  margin-bottom: 0.35rem;
}

.wsa-markdown a {
  color: var(--primary);
  font-weight: 500;
  word-break: break-word;
}

.wsa-markdown a:hover {
  text-decoration: underline;
}

.wsa-markdown strong {
  color: var(--text-strong);
}

.wsa-error {
  color: var(--danger);
}

.wsa-file-input {
  display: none;
}

.wsa-attach-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  margin-left: 4px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.wsa-attach-button:hover:not(:disabled) {
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}

.wsa-attach-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wsa-user-image-bubble {
  background: var(--surface);
  color: var(--text);
  padding: 8px;
  border: 1px solid var(--border);
}

.wsa-user-image-message {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-end;
}

.wsa-uploaded-image {
  display: block;
  max-width: 280px;
  max-height: 220px;
  width: auto;
  height: auto;
  border-radius: 10px;
  object-fit: contain;
  background: var(--surface-2);
}

.wsa-image-filename {
  font-size: 12px;
  color: var(--text-muted);
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wsa-image-caption {
  font-size: 14px;
  color: var(--text);
  max-width: 280px;
  word-break: break-word;
}

.wsa-pending-attachment {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding: 8px 12px;
  background: var(--surface-3);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.wsa-pending-thumb {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
}

.wsa-pending-name {
  flex: 1 1;
  font-size: 14px;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wsa-pending-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.wsa-pending-remove:hover:not(:disabled) {
  color: var(--danger);
  background: rgba(220, 38, 38, 0.1);
}

.wsa-pending-remove:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wsa-loading {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.wsa-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid var(--border);
  border-top-color: #667eea;
  border-radius: 50%;
  animation: wsa-spin 0.8s linear infinite;
  flex-shrink: 0;
}

@keyframes wsa-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .wsa-chat {
    margin: 0;
    height: calc(100dvh - 80px);
    max-height: calc(100dvh - 80px);
    max-width: 100% !important;
  }

  .wsa-markdown {
    font-size: 14px;
  }

  .wsa-uploaded-image,
  .wsa-image-filename,
  .wsa-image-caption {
    max-width: min(280px, calc(100vw - 96px));
  }

  .wsa-pending-attachment {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/web-suggested-actions/index.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,SAAS;IACT,2BAA2B;IAC3B,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,yCAAyC;EAC3C;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".wsa-chat {\n  margin: 20px auto;\n}\n\n.wsa-markdown {\n  text-align: left;\n  line-height: 1.6;\n  font-size: 15px;\n  color: var(--text);\n}\n\n.wsa-markdown h3 {\n  margin: 1rem 0 0.5rem;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text-strong);\n}\n\n.wsa-markdown p {\n  margin: 0 0 0.75rem;\n}\n\n.wsa-markdown ul,\n.wsa-markdown ol {\n  margin: 0.5rem 0 0.75rem;\n  padding-left: 1.25rem;\n}\n\n.wsa-markdown li {\n  margin-bottom: 0.35rem;\n}\n\n.wsa-markdown a {\n  color: var(--primary);\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.wsa-markdown a:hover {\n  text-decoration: underline;\n}\n\n.wsa-markdown strong {\n  color: var(--text-strong);\n}\n\n.wsa-error {\n  color: var(--danger);\n}\n\n.wsa-file-input {\n  display: none;\n}\n\n.wsa-attach-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  margin-left: 4px;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.wsa-attach-button:hover:not(:disabled) {\n  color: #667eea;\n  background: rgba(102, 126, 234, 0.1);\n}\n\n.wsa-attach-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.wsa-user-image-bubble {\n  background: var(--surface);\n  color: var(--text);\n  padding: 8px;\n  border: 1px solid var(--border);\n}\n\n.wsa-user-image-message {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-end;\n}\n\n.wsa-uploaded-image {\n  display: block;\n  max-width: 280px;\n  max-height: 220px;\n  width: auto;\n  height: auto;\n  border-radius: 10px;\n  object-fit: contain;\n  background: var(--surface-2);\n}\n\n.wsa-image-filename {\n  font-size: 12px;\n  color: var(--text-muted);\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.wsa-image-caption {\n  font-size: 14px;\n  color: var(--text);\n  max-width: 280px;\n  word-break: break-word;\n}\n\n.wsa-pending-attachment {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  padding: 8px 12px;\n  background: var(--surface-3);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n}\n\n.wsa-pending-thumb {\n  width: 40px;\n  height: 40px;\n  border-radius: 6px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.wsa-pending-name {\n  flex: 1;\n  font-size: 14px;\n  color: var(--text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.wsa-pending-remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.wsa-pending-remove:hover:not(:disabled) {\n  color: var(--danger);\n  background: rgba(220, 38, 38, 0.1);\n}\n\n.wsa-pending-remove:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.wsa-loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.wsa-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--border);\n  border-top-color: #667eea;\n  border-radius: 50%;\n  animation: wsa-spin 0.8s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes wsa-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .wsa-chat {\n    margin: 0;\n    height: calc(100dvh - 80px);\n    max-height: calc(100dvh - 80px);\n    max-width: 100% !important;\n  }\n\n  .wsa-markdown {\n    font-size: 14px;\n  }\n\n  .wsa-uploaded-image,\n  .wsa-image-filename,\n  .wsa-image-caption {\n    max-width: min(280px, calc(100vw - 96px));\n  }\n\n  .wsa-pending-attachment {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
